import { Box, Button, Card, CardContent, CardMedia, Container, Grid, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@material-ui/core";
import territory from '../../../assets/image/slick/territory-desktop-tab.webp';
import { useEffect, useState } from "react";
import GoogleSheetsService from "../../../services/GoogleSheetsService";
import { Link } from 'react-router-dom';
const Explorer = () => {
    const classes = useStyles();
    const [data, setData] = useState([]);
    useEffect(() => {
        const fetchData = async (sheetName) => {
            try {
                const data = await GoogleSheetsService.getData(sheetName, 'A:H');
                console.log(data);
                const fordData = data.find(item => item.tenLink === 'ford-explorer');
                setData(fordData);
            } catch (err) {
            }
        };

        fetchData('explorer');
    }, []);

    return (
        <Box className={classes.root}>
            <div className={classes.root}>
                <div className={classes.slide}>
                    <img src='https://www.ford.com.vn/content/ford/vn/vi_vn/site-wide-content/billboard-carousels/limited-carousel/jcr:content/par/billboard/imageComponent/image.imgs.full.high.jpg' className={classes.image} />
                    <Box className={classes.overlay}>
                        <Typography variant="h2" className={classes.title}>
                            Ford Explorer
                        </Typography>
                        <Button variant="contained" className={classes.exploreButton}>
                            Đăng ký lái thử
                        </Button>
                    </Box>
                </div>
            </div>
            <Container maxWidth="lg" className={classes.container}>
                <Box className={classes.boxTen}>
                    <Typography variant="h1" className={classes.title22} >
                        {data.tendaydu}
                    </Typography>
                    <Typography variant="body1"  >
                        {data.motangan}
                    </Typography>
                </Box>
                <Box>
                    <img className={classes.image2Web} src={data.anhnoidung} />
                </Box>
                <Box className={classes.boxNoiDung}>
                    <Typography variant="body1" className={classes.noiDung}>
                        Giá niêm yết từ:
                    </Typography>
                    <Typography variant="body1" className={classes.noiDung}>
                        {data.gia} VNĐ
                    </Typography>
                    <br />
                    <Typography variant="body1" className={classes.noiDung}>
                        Động cơ
                    </Typography>
                    <Typography variant="body1" className={classes.noiDung}>
                        {data.dongco}
                    </Typography>
                    <br />
                    <Typography variant="body1" className={classes.noiDung}>
                        Số chỗ
                    </Typography>
                    <Typography variant="body1" className={classes.noiDung}>
                        7 chỗ
                    </Typography>
                    <br />
                    <Typography variant="body1" className={classes.noiDung}>
                        Kích thước: Dài x Rộng x Cao (mm)
                    </Typography>
                    <Typography variant="body1" className={classes.noiDung}>
                        5049 x 2004 x 1778
                    </Typography>
                </Box>

                <Box>
                    <Grid container className={classes.gird4}>
                        <Grid item xs={12} md={6} >
                            <Box className={classes.contentChild}>
                                <Box height="100%" className={classes.boxImg4}>
                                    <img className={classes.imageWeb} src='https://www.ford.com.vn/content/ford/vn/vi_vn/home/suvs/explorer/limited/jcr:content/par/splitter/splitter0/image/image.imgs.full.high.jpg' />
                                </Box>
                                <Box className={classes.box1}>
                                    <Typography variant="h1" className={classes.title1}>
                                        Thiết kế khí động học
                                    </Typography>
                                    <Typography variant="body6">
                                        Lưới tản nhiệt của Explorer mang kiểu dáng hiện đại và khí động học. Với những đường dập táo bạo cùng đường viền bao quanh tinh tế, Explorer tự tin chinh phục ngay từ cái nhìn đầu tiên.
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6} >
                            <Box className={classes.contentChild}>
                                <Box height="100%" className={classes.boxImg4}>
                                    <img className={classes.imageWeb} src='https://www.ford.com.vn/content/ford/vn/vi_vn/home/suvs/explorer/limited/jcr:content/par/splitter/splitter1/image_1653695035/image.imgs.full.high.jpg' />
                                </Box>
                                <Box className={classes.box1}>
                                    <Typography variant="h1" className={classes.title1}>
                                        Camera phía sau
                                    </Typography>
                                    <Typography variant="body6">
                                        Camera phía sau trên Explorer giúp cung cấp tầm nhìn phía sau xe cho chủ sở hữu.
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6} >
                            <Box className={classes.contentChild}>
                                <Box height="100%" className={classes.boxImg4}>
                                    <img className={classes.imageWeb} src='https://www.ford.com.vn/content/ford/vn/vi_vn/home/suvs/explorer/limited/jcr:content/par/splitter/splitter20/image/image.imgs.full.high.jpg' />
                                </Box>
                                <Box className={classes.box1}>
                                    <Typography variant="h1" className={classes.title1}>
                                        Bậc lên xuống hàng ghế thứ 2
                                    </Typography>
                                    <Typography variant="body6">
                                        Bậc lên xuống hàng ghế thứ 2 giúp việc lên và xuống xe trở nên thật dễ dàng.
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6} >
                            <Box className={classes.contentChild}>
                                <Box height="100%" className={classes.boxImg4}>
                                    <img className={classes.imageWeb} src='https://www.ford.com.vn/content/ford/vn/vi_vn/home/suvs/explorer/limited/jcr:content/par/splitter/splitter21/image/image.imgs.full.high.jpg' />
                                </Box>
                                <Box className={classes.box1}>
                                    <Typography variant="h1" className={classes.title1}>
                                        Sạc không dây
                                    </Typography>
                                    <Typography variant="body6">
                                        Không còn những rắc rối mỗi lần tìm dây sạc. Chỉ cần đặt điện thoại lên bàn sạc và tiếp tục hành trình của bạn.
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6} >
                            <Box className={classes.contentChild}>
                                <Box height="100%" className={classes.boxImg4}>
                                    <img className={classes.imageWeb} src='https://www.ford.com.vn/content/ford/vn/vi_vn/home/suvs/explorer/limited/jcr:content/par/splitter/splitter30/image/image.imgs.full.high.jpg' />
                                </Box>
                                <Box className={classes.box1}>
                                    <Typography variant="h1" className={classes.title1}>
                                        Rèm chắn nắng cửa sổ tự cuộn
                                    </Typography>
                                    <Typography variant="body6">
                                        Rèm chắn nắng cửa sổ tự cuộn được trang bị trên cửa kính xe giúp khách hàng cảm thấy dễ chịu hơn trong những chuyến đi xa.
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6} >
                            <Box className={classes.contentChild}>
                                <Box height="100%" className={classes.boxImg4}>
                                    <img className={classes.imageWeb} src='https://www.ford.com.vn/content/ford/vn/vi_vn/home/suvs/explorer/limited/jcr:content/par/splitter/splitter31/image/image.imgs.full.high.jpg/1649753137524.jpg' />
                                </Box>
                                <Box className={classes.box1}>
                                    <Typography variant="h1" className={classes.title1}>
                                        Gương chiếu hậu ngoài
                                    </Typography>
                                    <Typography variant="body6">
                                        Gập điện tự động với chức năng nhớ vị trí
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                <Box className={classes.boxNoiDung}>
                    <Typography variant="h1" className={classes.title1}>
                        Mức tiêu thụ nhiên liệu (Lít/100km)
                    </Typography>
                    <TableContainer >
                        <Table sx={{ minWidth: 300 }} aria-label="fuel consumption table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Loại xe</TableCell>
                                    <TableCell align="right">Chu trình tổ hợp</TableCell>
                                    <TableCell align="right">Chu trình đô thị cơ bản</TableCell>
                                    <TableCell align="right">Chu trình đô thị phụ</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow key="ford-explorer">
                                    <TableCell component="th" scope="row">
                                        FORD EXPLORER LIMITED 2.3L ECOBOOST I4
                                    </TableCell>
                                    <TableCell align="right">11.24</TableCell>
                                    <TableCell align="right">13.42</TableCell>
                                    <TableCell align="right">9.96</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
                <Box className={classes.boxNoiDung}>
                    <Typography variant="h1" className={classes.title1}>
                        Ngoại Thất
                    </Typography>
                    <Grid container className={classes.gird4}>
                        <Grid item xs={12} md={6} >
                            <Box className={classes.contentChild}>
                                <Box height="100%" className={classes.boxImg4}>
                                    <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/website-assets/ap/vn/nameplate/explorer-new/360/exterior/360-image-07.jpg.dam.full.high.jpg/1644378269526.jpg' />
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6} >
                            <Box className={classes.contentChild}>
                                <Box height="100%" className={classes.boxImg4}>
                                    <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/website-assets/ap/vn/nameplate/explorer-new/360/exterior/360-image-72.jpg.dam.full.high.jpg/1644378289305.jpg' />
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6} >
                            <Box className={classes.contentChild}>
                                <Box height="100%" className={classes.boxImg4}>
                                    <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/website-assets/ap/vn/nameplate/explorer-new/360/exterior/360-image-24.jpg.dam.full.high.jpg/1644378275054.jpg' />
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6} >
                            <Box className={classes.contentChild}>
                                <Box height="100%" className={classes.boxImg4}>
                                    <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/website-assets/ap/vn/nameplate/explorer-new/360/exterior/360-image-66.jpg.dam.full.high.jpg/1644378288069.jpg' />
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6} >
                            <Box className={classes.contentChild}>
                                <Box height="100%" className={classes.boxImg4}>
                                    <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/website-assets/ap/vn/nameplate/explorer-new/360/exterior/360-image-41.jpg.dam.full.high.jpg/1644378279953.jpg' />
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6} >
                            <Box className={classes.contentChild}>
                                <Box height="100%" className={classes.boxImg4}>
                                    <img className={classes.imageWeb} src='https://www.ford.com.vn/content/dam/Ford/website-assets/ap/vn/nameplate/explorer-new/360/exterior/360-image-37.jpg.dam.full.high.jpg/1644378280328.jpg' />
                                </Box>

                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Container>

        </Box >
    );
};
export default Explorer;

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: '100%', // Đảm bảo slider chiếm hết chiều rộng container
        margin: '0 auto', // Căn giữa slider nếu cần
        backgroundColor: '#fff'
    },
    boxTen: {
        textAlign: 'center',
        marginBottom: theme.spacing(4),
        padding: '0 75px'
    },
    boxNoiDung: {
        marginTop: theme.spacing(4),
        textAlign: 'center',
    },
    noiDung: {
        color: '#00095b',
        fontWeight: 600
    },
    image: {
        display: 'block',
        width: '100%',
        height: 'auto',
    },
    overlay: {
        position: 'absolute', // Định vị tuyệt đối
        bottom: theme.spacing(5), // Cách đáy một khoảng
        left: theme.spacing(10), // Cách lề trái một khoảng
        color: 'white', // Màu chữ trắng
        padding: theme.spacing(2),
        zIndex: 1, // Đảm bảo overlay nằm trên ảnh
    },
    title: {
        marginBottom: theme.spacing(1),
    },
    exploreButton: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
        },
    },
    container: {
        marginTop: theme.spacing(8),
    },
    title21: {
        fontSize: '3rem', // Kích thước chữ lớn
        fontWeight: 'bold',
        marginBottom: theme.spacing(2), // Khoảng cách dưới tiêu đề
        color: '#066fef !important'
    },
    title22: {
        fontSize: '3rem', // Kích thước chữ lớn
        fontWeight: 'bold',
        marginBottom: theme.spacing(2), // Khoảng cách dưới tiêu đề
        color: '#00095b !important'
    },
    image2Web: {
        width: '100%',
        borderRadius: '10px'
    },
    title1: {
        fontSize: '2rem', // Kích thước chữ lớn
        fontWeight: 'bold',
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(2), // Khoảng cách dưới tiêu đề
        color: '#00095b !important'
    },
    gridParent: {
        display: 'flex',
        alignItems: 'center'
    },
    box1: {
        marginTop: theme.spacing(1)
    },
    boxList: {
        marginTop: theme.spacing(6)
    },
    link: {
        textDecoration: 'none !important',
        color: 'inherit !important', // Kế thừa màu từ button
        '&:hover': {
            textDecoration: 'none !important',
            color: 'inherit !important',
        },
        '&:focus': {
            outline: 'none !important',
        },
    },
    button: {
        backgroundColor: '#1976d2',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#1565c0',
        },
        [theme.breakpoints.up('md')]: {
            marginTop: theme.spacing(2),
        },
    },
    imageWeb: {
        display: 'block',
        width: '100%',
        height: '100%', // Ảnh lấp đầy container
        objectFit: 'cover',  // Đảm bảo ảnh không bị méo
        borderRadius: '10px'
    },
    contentChild: {
        padding: theme.spacing(1),
        marginTop: theme.spacing(4),
    }
}));